import {deleteRequest, getRequest, postRequest, putRequest} from "../../httpClient";



export async function fetchStudyNotes(token) {
    return  await getRequest(`/v3/study-notes`, token)
        .then(resp => {
            if (resp.ok) {
                return resp.json();
            }
            throw resp
        })
        .catch(err => err);
}

export async function fetchStudyNote(token, noteId) {
    return  await getRequest(`/v3/study-notes/${noteId}`, token)
        .then(resp => {
            if (resp.ok) {
                return resp.json();
            }
            throw resp
        })
        .catch(err => err);
}

export async function createStudyNote(token, noteRequest) {
    return  await postRequest(`/v3/study-notes`, token, noteRequest)
        .then(resp => {
            if (resp.ok) {
                return resp.json();
            }
            throw resp
        })
        .catch(err => err);
}

export async function updateStudyNote(token, noteRequest, noteId) {
    return  await putRequest(`/v3/study-notes/${noteId}`, token, noteRequest)
        .then(resp => {
            if (resp.ok) {
                return resp.json();
            }
            throw resp
        })
        .catch(err => err);
}

export async function deleteStudyNote(token, noteId) {
    return  await deleteRequest(`/v3/study-notes/${noteId}`, token)
        .then(resp => {
            if (resp.ok) {
                return resp.json();
            }
            throw resp
        })
        .catch(err => err);
}

